module.exports = __webpack_public_path__ + "static/media/videos-2@2x.ad7a1c00.jpg";